<template>
	<div id="Departments" class="animated fadeIn">
		<b-row>
			<b-col sm="8" class="treeColumn">
				<h2 id="departmentsTitle">{{ $t('section.title') }}</h2>
				<b-link @click="showRefModal({ dep: {}, forAdding: true })" size="sm" variant="primary"
					v-if="$can('create/edit', 'department')">
					<i id="addDepIcon" class="fa fa-plus-circle" v-b-tooltip.hover :title="$t('section.create.create')"
						style="font-size: 1.4em;color: #53575B"></i>
				</b-link>
				<b-alert v-if="notAllowedErrorDep" :show="dismissCountDown" dismissible variant="warning"
					@dismissed="dismissCountDown = 0" @dismiss-count-down="countDownChanged">
					<p>{{ deleteDepErrorMessage }}</p>
				</b-alert>
				<!-- TREE VIEW -->
				<ul v-if="getDepartments.length > 0">
					<template v-for="dep in getDepartments">
						<tree-view @showRefModal="showRefModal" @deleteDep="deleteDepartment" class="item"
							:key="dep.id + 'dep'" :model="dep">
						</tree-view>
					</template>
				</ul>
				<template v-else>
					<h4 style="margin: .5em 0 .5em 0; font-size: 1.1rem">Hozircha bo'limlar qo'shilmagan</h4>
					<p style="margin: .1em 0 4em 0;">Qo'shish belgili tugmachaga bosib bo'lim qo'shishingiz mumkin</p>
				</template>
				<!-- TREE VIEW -->
			</b-col>
			<div>

				<!-- MODAL FOR ADDING AND EDITING DEPARTMENT -->
				<b-modal body-class="refModal" ref="updateRefModal" id="modal" hide-footer v-model="showDepModal"
					ok-title="Save" class="departmentModal">
					<div slot="modal-title">
						<span v-if="modalForAdding">{{ $t('section.create.create') }}</span>
						<span v-if="!modalForAdding">{{ $t('section.create.update') }}</span>
					</div>
					<b-alert v-if="addDepError" :show="dismissCountDown" dismissible style="margin-bottom: 10px;"
						variant="warning" size="sm" @dismissed="dismissCountDown = 0"
						@dismiss-count-down="countDownChanged">
						<p v-if="typeof addDepErrorMessages === 'string'">
							{{ addDepErrorMessages }}
						</p>
						<p v-else v-for="(message, index) in addDepErrorMessages" :key="'message' + index">
							{{ $t(message) }}
						</p>
					</b-alert>
					<div>
						<p v-if="depInputNotFilled" style="color: red;">{{ $t('please-title') }}</p>

						<b-form-group label-cols="4" label-cols-lg="2" label-size="sm"
							:label="$t('section.create.name') + ':'" label-for="refName" class="required">
							<b-form-input :required="true"
								data-errormessage-value-missing="Bu maydon to'ldirilishi shart!" id="refName" size="sm"
								v-model="item.name" v-on="modalForAdding ? { input: nameAndShortNameSync } : {}"
								:placeholder="$t('section.create.section-name')" />
						</b-form-group>

						<b-form-group label-cols="4" label-cols-lg="2" label-size="sm"
							:label="$t('section.create.short-name') + ':'" label-for="refValue">
							<b-form-input id="refValue" size="sm" v-model="item.shortName"
								v-on="modalForAdding ? { blur: shortNameChanged } : {}"
								:placeholder="$t('section.create.section-short-name')" />
						</b-form-group>

						<b-form-group label-cols="4" label-cols-lg="2" label-size="sm"
							:label="$t('department.type') + ':'" label-for="refCode" class="required">
							<b-input-group>
								<b-form-select v-model="item.typeId" :plain="false" :options="getRefChildren" size="sm"
									:required="true" :text-field="'name'" :value-field="'id'"
									data-errormessage-value-missing="Bu maydon to'ldirilishi shart!">
									<template slot="first">
										<option :value="null" disabled>-- {{ $t('section.create.select-section-type') }}
											--</option>
									</template>
								</b-form-select>
								<b-input-group-append>
									<b-input-group-addon>
										<b-button type="button" @click="nestedModalShow = !nestedModalShow"
											v-b-modal.modal-add v-b-tooltip.hover
											:title="$t('section.create-section-type.title')" size="sm"
											variant="outline-default"><i class="fa fa-plus"></i></b-button>
									</b-input-group-addon>
								</b-input-group-append>
							</b-input-group>
						</b-form-group>

						<b-form-group label-cols="4" label-cols-lg="2" label-size="sm"
							:label="$t('department.saleType') + ':'" label-for="refCode" class="required">
							<b-input-group>
								<b-form-select v-model="item.saleType" :plain="false" :options="saleTypeOptions"
									size="sm" :required="true" :text-field="'text'" :value-field="'value'"
									data-errormessage-value-missing="Bu maydon to'ldirilishi shart!">
									<template slot="first">
										<option :value="null">-- {{ $t('section.create.select-saletype') }} --</option>
									</template>
								</b-form-select>
							</b-input-group>
						</b-form-group>
						<b-form-group label-cols="4" label-cols-lg="2" label-size="sm"
							:label="$t('department.money-type') + ':'" label-for="depCurrency">
							<b-form-select v-model="item.currencyId" :plain="false" :options="refCurrencies" size="sm"
								id="depCurrency" :text-field="'name'" :value-field="'id'">
								<template slot="first">
									<option :value="null" disabled>-- {{ $t('department.money-type-department') }} --
									</option>
								</template>
							</b-form-select>
						</b-form-group>

						<b-form-group label-cols="4" label-cols-lg="2" label-size="sm"
							:label="$t('section.create.address') + ':'" label-for="refSort">
							<b-form-textarea id="refSort" size="sm" type="text" v-model="item.address" rows="3"
								max-rows="6" :placeholder="$t('section.create.section-address')" />
						</b-form-group>
						<b-form-group label-cols="4" label-cols-lg="2" label-size="sm"
							:label="$t('section.create.comment') + ':'" label-for="refComment">
							<b-form-textarea id="refComment" size="sm" v-model="item.comment" rows="3" max-rows="6"
								:placeholder="$t('section.create.section-comment')" />
						</b-form-group>
						<b-form-group breakpoint="lg" label-size="sm" label-cols="2" label-for="vatPercentage">
							<template slot="label">{{ $t('section.create.vatPercentage') }}</template>
							<b-input-group size="sm">
								<b-form-input size="sm" id="inUzs" autocomplete="off" type="number"
									v-model="item.vatPercentage" :placeholder="$t('section.create.vatPercentage')" />
								<b-input-group-addon>
									<b-button disabled size="sm">%</b-button>
								</b-input-group-addon>
							</b-input-group>
						</b-form-group>
						<b-row>
							<b-col>
								<b-form-group label-cols="6" label-cols-lg="6" label-size="sm" label="Реквизиты"
									label-for="depRequisiteId">
									<b-row class="my-1">
										<b-col sm="12">
											<b-checkbox v-model="item.withRequisite" id="depRequisiteId"></b-checkbox>
										</b-col>
									</b-row>
								</b-form-group>
							</b-col>
							<b-col>
								<b-form-group label-cols="6" label-cols-lg="6" label-size="sm" label="С ИКПУ"
									label-for="dipShop">
									<b-row class="my-1">
										<b-col sm="12">
											<b-checkbox v-model="item.forMxik" id="dipShop" switch />
										</b-col>
									</b-row>
								</b-form-group>
							</b-col>
							<b-col>
								<b-form-group label-cols="6" label-cols-lg="6" label-size="sm" label="DipShop"
									label-for="mxikRequired">
									<b-row class="my-1">
										<b-col sm="12">
											<b-checkbox v-model="item.isDipShop" id="mxikRequired" switch />
										</b-col>
									</b-row>
								</b-form-group>
							</b-col>
						</b-row>


						<template v-if="item.withRequisite">
							<b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="ИНН" label-for="inn">
								<b-form-input size="sm" id="inn" v-model="item.inn" placeholder="ИНН" />
							</b-form-group>

							<b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="ОКОНХ"
								label-for="okonx">
								<b-form-input size="sm" id="okonx" v-model="item.okonx" placeholder="ОКОНХ" />
							</b-form-group>
							<!-- yangi qo'shilgan inputlar -->
							<b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="c/b" label-for="cb">
								<b-form-input size="sm" id="cb" v-model="item.cb" placeholder="C/B" />
							</b-form-group>

							<b-form-group label-cols="4" label-cols-lg="2" label-size="sm"
								:label="$t('contragent.bankName')" label-for="bankName">
								<b-form-input size="sm" id="bankName" v-model="item.bankName"
									:placeholder="$t('contragent.bankName')" />
							</b-form-group>

							<b-form-group label-cols="4" label-cols-lg="2" label-size="sm"
								:label="$t('contragent.filialName')" label-for="filialName">
								<b-form-input size="sm" id="filialName" v-model="item.bankFilialName"
									:placeholder="$t('contragent.filialName')" />
							</b-form-group>
							<!-- yangi qo'shilgan inputlar -->
							<b-form-group breakpoint="lg" label-size="sm" label-cols="2" :label="$t('contragent.bank')"
								label-for="okonx">
								<b-form-input size="sm" id="bank" v-model="item.bankAccount"
									:placeholder="$t('contragent.bank')" />
							</b-form-group>
							<b-form-group breakpoint="lg" label-size="sm" label-cols="2" :label="$t('contragent.ndc')"
								label-for="okonx">
								<b-form-input size="sm" id="ndc" v-model="item.vatAccount"
									:placeholder="$t('contragent.ndc')" />
							</b-form-group>

							<b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Телефон"
								label-for="phone">
								<b-form-input size="sm" id="phone" v-model="item.phone" placeholder="Телефон" />
							</b-form-group>

							<b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="ФИО Гл. бухгалтера"
								label-for="accountantFullName">
								<b-form-input size="sm" id="accountantFullName" v-model="item.accountantFullName"
									placeholder="ФИО Гл. бухгалтера" />
							</b-form-group>
						</template>
						<b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Склад" label-for="sklad">
							<b-row class="my-1">
								<b-col sm="12">
									<b-checkbox v-model="item.isStock" id="sklad" switch />
								</b-col>
							</b-row>
						</b-form-group>

						<b-form-group label-cols="6" label-cols-lg="6" label-size="sm"
							label="Торговля наличными средствами не ограничивается" label-for="cashSaleAllowed">
							<b-row class="my-1">
								<b-col sm="12">
									<b-checkbox v-model="item.cashSaleAllowed" id="cashSaleAllowed"></b-checkbox>
								</b-col>
							</b-row>
						</b-form-group>

						<div class="createRoleModalButtons row mt-3 justify-content-end">
							<div class="col-4">
								<b-button variant="outline-danger" size="sm" block @click="closeUpdateRefModal">{{
									$t('actions.cancel') }}
								</b-button>
							</div>
							<div class="col-4">
								<b-button variant="outline-success" size="sm" block @click="saveRef">{{
									$t('actions.save')
								}}</b-button>
							</div>
						</div>
					</div>
				</b-modal>
				<!-- MODAL FOR ADDING OR EDITING DEPARTMENT -->

				<!-- MODAL FOR ADDING OR EDITING REFERENCE -->
				<b-modal body-class="nestedRefModal refModal" v-model="nestedModalShow" ref="updateNestedRefModal"
					id="modal-add" hide-footer ok-title="Save" :title="$t('section.create-section-type.title')">
					<create-ref-modal-content :parent="'department'" :parentCode="depTypeRefCode" :propItem="itemRef"
						@closeUpdateRefModal="closeNestedUpdateRefModal">

					</create-ref-modal-content>
				</b-modal>
				<!-- MODAL FOR ADDING OR EDITING REFERENCE -->
			</div>
		</b-row>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import TreeView from './TreeView'
import CreateRefModalContent from '../../references/blocks/CreateRefModalContent'

const itemInitial = {
	id: '',
	address: '',
	comment: '',
	name: '',
	shortName: '',
	saleType: '',
	typeId: null,
	currencyId: null,
	withRequisite: false,
	forMxik: false,
	isDipShop: false,
	isStock: false,
	cashSaleAllowed: false,
	inn: '',
	okonx: '',
	bankAccount: '',
	vatAccount: '',
	phone: '',
	accountantFullName: '',
	vatPercentage: '',
	bankName: '',
	cb: '',
	bankFilialName: ''
};
const itemInitialRef = {
	id: null,
	parentId: null,
	parentName: '',
	code: '',
	name: '',
	value: '',
	sort: null
};
export default {
	name: "Departments",
	components: {
		TreeView,
		CreateRefModalContent
	},
	data() {
		return {

			param: {
				page: 0,
				limit: 20
			},
			/* DATA FOR ALERT WHEN DELETED 'NOT_ALLOWED' REFERENCE BEGIN */
			dismissCountDown: 4,
			/* DATA FOR ALERT WHEN DELETED 'NOT_ALLOWED' REFERENCE END */
			currentPage: 1,
			perPage: 20,
			editable: false,
			isBusy: false,
			focusedData: {
				id: null,
				key: null
			},
			saleTypeOptions: [
				{ value: 'RETAIL', text: this.$t('warehouse.table.tableRetail') },
				{ value: 'WHOLE', text: this.$t('sidebar.warehouse-management.wholesale') },
			],
			depInputNotFilled: false,
			nestedRefInputNotFilled: false,
			newDep: {
				name: '',
				code: ''
			},
			tempData: Object.assign({}, itemInitial),
			tempDataRef: Object.assign({}, itemInitialRef),
			item: Object.assign({}, itemInitial),
			itemRef: Object.assign({}, itemInitialRef),
			modalForAdding: false,
			showDepModal: false,
			nestedModalForAdding: false,
			nestedModalShow: false,
			shortNameSelfChanged: false,
			depTypeRefCode: 'DEPARTMENT_TYPE'
		}
	},
	methods: {
		...mapActions('departments', [
			'getDepartmentsList', 'updateOrCreateChildDep', 'deleteDep'
		]),
		...mapActions('references', [
			'getReferenceChildren',
		]),
		/* POPOVER METHODS BEGIN */
		onOpen(itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('open')
		},
		onClose(itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('close')
		},
		async onOk(itemId) {
			this.onClose(itemId)
			await this.deleteDepartment(itemId);
		},
		/* POPOVER METHODS END */

		countDownChanged(dismissCountDown) {
			if (dismissCountDown <= 1) {
				dismissCountDown = 3;
			}
			this.dismissCountDown = dismissCountDown
		},
		vatChanged($event) {
		},
		async deleteDepartment(id) {
			await this.deleteDep(id);
			await this.getDepartmentsList();
			if (this.notAllowedErrorDep) {
				setTimeout(() => {
					this.$store.commit('departments/deleteDepError', { message: '', boolean: false })
				}, 4000)
			}
		},

		/* showRefModal RECEIVES OBJ CONTAINS DEPARTMENT AND 'forAdding' BOOLEAN */
		async showRefModal(depAndForAdding) {
			await this.getReferenceChildren(this.depTypeRefCode);
			await this.getReferenceChildren('CURRENCY');
			this.shortNameSelfChanged = false;
			this.depInputNotFilled = false;
			this.nestedRefInputNotFilled = false;
			if (depAndForAdding.forAdding) {
				this.item = Object.assign({}, itemInitial);
				this.tempData = Object.assign({}, itemInitial);
				this.item.parentId = depAndForAdding.dep.id ? depAndForAdding.dep.id : null;
				this.modalForAdding = true;
				this.showDepModal = true;
				this.$refs.updateRefModal.show();
			} else {
				this.tempData = depAndForAdding.dep;
				this.modalForAdding = false;

				this.item.id = depAndForAdding.dep.id;
				this.item.parentId = depAndForAdding.dep.id ? depAndForAdding.dep.id : null;
				this.item.name = depAndForAdding.dep.name;
				this.item.address = depAndForAdding.dep.address;
				this.item.comment = depAndForAdding.dep.comment;
				this.item.shortName = depAndForAdding.dep.shortName ? depAndForAdding.dep.shortName : '';
				this.item.typeId = depAndForAdding.dep.typeId ? depAndForAdding.dep.typeId : null;
				this.item.currencyId = depAndForAdding.dep.currencyId ? depAndForAdding.dep.currencyId : null;
				this.item.withRequisite = depAndForAdding.dep.withRequisite;
				this.item.forMxik = depAndForAdding.dep.forMxik;
				this.item.isDipShop = depAndForAdding.dep.isDipShop;
				this.item.isStock = depAndForAdding.dep.isStock;
				this.item.cashSaleAllowed = depAndForAdding.dep.cashSaleAllowed;
				this.item.inn = depAndForAdding.dep.inn;
				this.item.saleType = depAndForAdding.dep.saleType ? depAndForAdding.dep.saleType : null;
				this.item.okonx = depAndForAdding.dep.okonx;
				this.item.bankAccount = depAndForAdding.dep.bankAccount;
				this.item.vatAccount = depAndForAdding.dep.vatAccount;
				this.item.bankName = depAndForAdding.dep.bankName;
				this.item.cb = depAndForAdding.dep.cb;
				this.item.bankFilialName = depAndForAdding.dep.bankFilialName
				this.item.accountantFullName = depAndForAdding.dep.accountantFullName;
				this.item.vatPercentage = depAndForAdding.dep.vatPercentage;
				this.showDepModal = true;
				this.$refs.updateRefModal.show();
			}
		},
		closeUpdateRefModal() {
			this.depInputNotFilled = false;
			this.showDepModal = false;
			this.$refs.updateRefModal.hide();
		},
		async saveRef() {
			if ((this.item.name ? this.item.name.trim() : '') != '' && (this.item.typeId ? this.item.typeId.toString().trim() : '') != '') {
				if (this.item.name.trim() != this.tempData.name.trim() || (this.item.typeId ? this.item.typeId.toString().trim() : '') != (this.tempData.typeId ? this.tempData.typeId.toString().trim() : '') ||
					(this.item.currencyId ? this.item.currencyId.toString().trim() : '') != (this.tempData.currencyId ? this.tempData.currencyId.toString().trim() : '') ||
					(this.item.address ? this.item.address.trim() : this.item.address) != (this.tempData.address ? this.tempData.address.trim() : this.tempData.address) ||
					(this.item.shortName ? this.item.shortName.trim() : this.item.shortName) != (this.tempData.shortName ? this.tempData.shortName.toString().trim() : this.tempData.shortName) ||
					this.item.withRequisite != this.tempData.withRequisite ||
					this.item.forMxik != this.tempData.forMxik ||
					this.item.cashSaleAllowed != this.tempData.cashSaleAllowed ||
					this.item.isDipShop != this.tempData.isDipShop || this.item.isStock != this.tempData.isStock ||
					(this.item.inn ? this.item.inn.trim() : this.item.inn) != (this.tempData.inn ? this.tempData.inn.trim() : this.tempData.inn) ||
					(this.item.vatPercentage ? this.item.vatPercentage : this.item.vatPercentage) != (this.tempData.vatPercentage ? this.tempData.vatPercentage : this.tempData.vatPercentage) ||
					(this.item.phone ? this.item.phone.trim() : this.item.phone) != (this.tempData.phone ? this.tempData.phone.trim() : this.tempData.phone) ||
					(this.item.okonx ? this.item.okonx.trim() : this.item.okonx) != (this.tempData.okonx ? this.tempData.okonx.trim() : this.tempData.okonx) ||
					(this.item.bankAccount ? this.item.bankAccount.trim() : this.item.bankAccount) != (this.tempData.bankAccount ? this.tempData.bankAccount.trim() : this.tempData.bankAccount) ||
					(this.item.vatAccount ? this.item.vatAccount.trim() : this.item.vatAccount) != (this.tempData.vatAccount ? this.tempData.vatAccount.trim() : this.tempData.vatAccount) ||
					(this.item.saleType ? this.item.saleType.trim() : this.item.saleType) != (this.tempData.saleType ? this.tempData.saleType.trim() : this.tempData.saleType) ||
					(this.item.accountantFullName ? this.item.accountantFullName.trim() : this.item.accountantFullName) != (this.tempData.accountantFullName ? this.tempData.accountantFullName.trim() : this.tempData.accountantFullName)
				) {

					this.depInputNotFilled = false;
					await this.updateOrCreateChildDep(this.item);
					if (this.addDepError) {
						await setTimeout(() => {
							this.$store.commit('departments/addDepError', { message: '', boolean: false })
						}, 4000)
					} else {
						this.getDepartmentsList();
						this.item = Object.assign({}, itemInitial);
						this.depInputNotFilled = false;
						this.showDepModal = false;
						this.$refs.updateRefModal.hide();
					}
				} else {
					this.depInputNotFilled = false;
					this.showDepModal = false;
					this.$refs.updateRefModal.hide();
				}
			} else {
				this.depInputNotFilled = true;
			}
		},
		nameAndShortNameSync(val) {
			if (!this.shortNameSelfChanged || this.item.shortName === '') {
				if (val.length <= 32) {
					this.item.shortName = val;
				} else {
					this.item.shortName = val.slice(0, 32)
				}
			}
		},
		shortNameChanged(e) {
			this.shortNameSelfChanged = e.target.value !== '';
		},
		closeNestedUpdateRefModal() {
			this.nestedRefInputNotFilled = false;
			this.$refs.updateNestedRefModal.hide();
		}
	},
	computed: {
		...mapState('departments', [
			'notAllowedErrorDep', 'deleteDepErrorMessage',
			'addDepError', 'addDepErrorMessages'
		]),
		...mapGetters('departments', [
			'getDepartments'
		]),
		...mapGetters('references', [
			'getRefChildren'
		]),
		...mapState('references', [
			'refCurrencies'
		])
	},
	watch: {
		'item.withRequisite': {
			handler(newVal, oldVal) {
			}
		},
	},
	async created() {
		await this.getDepartmentsList();
	}
}
</script>

<style scoped lang="scss">
#Departments {
	background-color: #ffffff;
	padding: 15px;
	min-height: 30rem;
}

#departmentsTitle {
	margin: .7em .9em .8em 0;
	display: inline-block;
	border-bottom: 1px solid #ccc;
}

#addDepIcon {
	display: inline-block;
}

.treeColumn {
	margin-left: 3rem;
}

li div div,
.add,
.delete {
	display: inline-block;
	cursor: pointer;
	margin: 8px 0;
}

li div div {
	&:hover {
		text-decoration: underline;
	}
}

li>.bold {
	font-weight: bold;
	display: inline-block;
}

ul {
	padding-left: 1.7em !important;
	line-height: 1.5em;
	list-style-type: none;
}
</style>
